import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'dashboardLinksCreatedByCategory.list'

const DashboardLinksCreatedByCategoryListSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default DashboardLinksCreatedByCategoryListSlice
